<template>
  <b-modal
    :title="getTitleModal"
    modal-class="batch-status-modal"
    hide-footer
    v-model="show"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="$emit('close')"
  >
    <div class="status-container">
      <!-- Cabecera -->
      <div
        class="status-header d-flex align-items-center justify-content-between mb-1"
      >
        <div class="d-flex align-items-center">
          <div
            :class="['status-icon', modalData.finished ? 'success' : 'loading']"
          >
            <i
              :class="[
                'bx',
                modalData.finished
                  ? 'bx-check-circle'
                  : 'bx-loader-circle bx-spin',
              ]"
            ></i>
          </div>
          <div class="ms-2">
            <h6 class="mb-0 text-primary fw-bold">
              {{ modalData.name || "Proceso en ejecución" }}
            </h6>
            <small>ID: {{ modalData.id }}</small>
          </div>
        </div>
        <div class="text-end">
          <span
            :class="[
              'status-state',
              modalData.finished ? 'text-success' : 'text-warning',
            ]"
          >
            {{ modalData.finished ? "Completado" : "Procesando..." }}
          </span>
        </div>
      </div>

      <!-- Progreso -->
      <div class="status-progress mb-1">
        <b-progress
          height="20px"
          :value="modalData.progress"
          variant="primary"
          animated
        >
          <b-progress-bar :value="modalData.progress"
            >{{ modalData.progress }}%</b-progress-bar
          >
        </b-progress>
      </div>

      <!-- Resumen compacto -->
      <b-row class="status-summary text-center small mb-1">
        <b-col>
          <div><strong>Total</strong></div>
          <div>{{ modalData.total_jobs }}</div>
        </b-col>
        <b-col>
          <div><strong>Procesados</strong></div>
          <div class="text-success">{{ modalData.processed_jobs }}</div>
        </b-col>
        <b-col>
          <div><strong>Correctos</strong></div>
          <div class="text-success">
            {{ modalData.processed_jobs - modalData.failed_jobs }}
          </div>
        </b-col>
        <b-col>
          <div><strong>Pendientes</strong></div>
          <div class="text-warning">{{ modalData.pending_jobs }}</div>
        </b-col>
        <b-col>
          <div><strong>Errores</strong></div>
          <div class="text-danger">{{ modalData.failed_jobs }}</div>
        </b-col>
      </b-row>

      <!-- Fechas -->
      <div class="status-times small mb-1 d-flex justify-content-between">
        <div>
          <strong>Inicio:</strong> {{ formatDate(modalData.created_at) }}
        </div>
        <div v-if="modalData.finished_at">
          <strong>Fin:</strong> {{ formatDate(modalData.finished_at) }}
        </div>
      </div>

      <!-- Errores detallados -->
      <div v-if="modalData.failed_jobs > 0" class="status-errors">
        <div class="mb-2 d-flex align-items-center">
          <i class="bx bx-error-circle me-2 text-danger fs-5"></i>
          <strong>Errores en algunos registros</strong>
        </div>
        <div class="error-list">
          <div
            v-for="job in modalData.failed_job_details"
            :key="job.payroll_id"
            class="error-card mb-2"
          >
            <div class="error-info">
              <div class="d-flex align-items-center mb-1">
                <b-badge
                  variant="danger"
                  class="mr-2"
                  v-b-tooltip="
                    modalData.name === 'Aprobación de planillas de conductores'
                      ? 'ID planilla conductor'
                      : 'ID planilla administrativa'
                  "
                  >#{{ job.payroll_id }}</b-badge
                >
                <router-link
                  target="_blank"
                  :class="[textLink, 'font-weight-semibold']"
                  :to="{
                    name: 'rrhh-employees-information',
                    params: { id: job.employee_id },
                  }"
                >
                  {{ job.employee | capitalize }}
                </router-link>
              </div>
              <div>{{ job.message }}</div>
            </div>
            <div class="error-icon">
              <b-icon
                icon="exclamation-triangle-fill"
                variant="danger"
              ></b-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- Botón -->
      <div class="text-center">
        <b-button
          v-if="modalData.finished"
          variant="primary"
          class="px-4"
          @click="$emit('close')"
        >
          Cerrar
        </b-button>
        <div v-else class="small">
          No cierre esta ventana hasta que el proceso termine.
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";

export default {
  name: "BatchStatusModal",
  props: {
    modalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return { show: true };
  },
  computed: {
    getTitleModal() {
      return "Estado del proceso";
    },
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mm:ss") : "—";
    },
  },
};
</script>

<style lang="scss">
.batch-status-modal {
  .status-container {
    font-family: "Inter", sans-serif;
    color: #444;
    padding: 1rem;
  }

  .status-header {
    .status-icon {
      font-size: 2rem;
      &.success {
        color: #28a745;
      }
      &.loading {
        color: #f0ad4e;
      }
    }
    .status-state {
      font-weight: 600;
    }
  }

  .status-progress .b-progress {
    border-radius: 8px;
  }

  .status-summary {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: #f8f9fa;
    padding: 0.5rem 0;
  }

  .status-times {
    border-top: 1px dashed #ddd;
    padding-top: 0.5rem;
    color: #666;
  }

  /* Errores */
  .status-errors {
    margin-top: 1rem;
  }
  .error-list {
    max-height: 200px;
    overflow-y: auto;
  }
  .error-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: #fff5f5;
    // border: 1px solid #f8d7da;
    border-left: 5px solid #f03e3e;
    border-radius: 8px;
    padding: 0.75rem 1rem;
  }

  .error-info {
    flex: 1;
    min-width: 0;
  }

  .error-icon {
    margin-left: 0.75rem;
    color: #f03e3e;
    font-size: 1.2rem;
  }

  .text-center .btn {
    border-radius: 6px;
    font-weight: 600;
  }
}

/* Modo oscuro */
.dark-layout {
  .batch-status-modal {
    .status-container {
      color: #ddd;
    }
    .status-summary {
      background: #3a3d42;
      border-color: #555;
    }
    .status-times {
      border-top-color: #555;
      color: #aaa;
    }
    .status-errors {
      .error-card {
        background: #3a3d42;
        border-left-color: #f03e3e;
        color: #fff;
      }
    }
  }
}
</style>
